<template>
  <ChartLineChart ref="chart" :chart-data="chartData" :chart-options="options" id="line-chart" />
</template>

<script>
import 'chart.js/auto';
import 'moment';
import { Line as ChartLineChart } from 'vue-chartjs/legacy';
import 'chartjs-adapter-moment';

export default {
  name: 'LineChart',
  components: {
    ChartLineChart,
  },
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chart: null
    };
  },
}
</script>
